import React, { ReactNode } from 'react';

export interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onChange, className = '' }) => {
  return (
    <div className={`flex border-b border-border-dark ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`
            flex items-center px-4 py-2 text-sm font-medium
            ${activeTab === tab.id 
              ? 'text-primary border-b-2 border-primary -mb-px' 
              : 'text-gray-400 hover:text-gray-100 hover:bg-slate-800/60'
            }
            transition-colors
          `}
          onClick={() => onChange(tab.id)}
        >
          {tab.icon && <span className="mr-1.5">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs; 